/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LeagueCategory = {
    properties: {
        category: {
            type: 'LeagueCategoryEnum',
            isRequired: true,
        },
        translation: {
            type: 'Translation',
            isRequired: true,
        },
    },
} as const;
